
export const fetchUser = () => {
   // console.log('LO QUE HAY AL PREGUNTAR ' + window.localStorage.getItem('profile'));
    if (window.localStorage.getItem('profile')){
        const userData = window.localStorage.getItem('profile') 
        ? JSON.parse(localStorage.getItem('profile')) : 
        null;
        return userData;
    }
    return null;
}

 